import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class NixieListVm {
	vendorId: number;
	nixieUploadId?: number;
	vendorName?: string;
	uploadFileName?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'vendorId': new UntypedFormControl(0, [...(validators['vendorId'] ?? []), ...[Validators.required]]),
			'nixieUploadId': new UntypedFormControl(null, [...(validators['nixieUploadId'] ?? []), ...[]]),
			'vendorName': new UntypedFormControl(null, [...(validators['vendorName'] ?? []), ...[]]),
			'uploadFileName': new UntypedFormControl(null, [...(validators['uploadFileName'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['vendorName', {"orderId":0,"sortColumn":"vendorName","searchColumn":"vendorName","includeInExcel":true,"exportColumn":null,"displayName":"Client","isVisible":true,"canSearch":true,"isNdc":false,"multiSearchCellClasses":null}],
			['uploadFileName', {"orderId":1,"sortColumn":"uploadFileName","searchColumn":"uploadFileName","includeInExcel":true,"exportColumn":null,"displayName":"Nixie File Upload","isVisible":true,"canSearch":false,"isNdc":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): NixieListVmFromFg {
		return new NixieListVmFromFg(fg);
	}
}

export class NixieListVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get vendorId(): number {
		return this.fg.get('vendorId').value;
	}
	set vendorId(val) {
		this.fg.get('vendorId').setValue(val);
	}

	get nixieUploadId(): number {
		return this.fg.get('nixieUploadId').value;
	}
	set nixieUploadId(val) {
		this.fg.get('nixieUploadId').setValue(val);
	}

	get vendorName(): string {
		return this.fg.get('vendorName').value;
	}
	set vendorName(val) {
		this.fg.get('vendorName').setValue(val);
	}

	get uploadFileName(): string {
		return this.fg.get('uploadFileName').value;
	}
	set uploadFileName(val) {
		this.fg.get('uploadFileName').setValue(val);
	}
}
